import React from 'react';
import { useTranslation } from 'react-i18next';

import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { getSimpleUpdateEventTranslation } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/helpers/styleHelpers';
import { isExtractorUser } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/helpers/dataHelpers';
import {
    HistoryUpdateContentT,
    HistoryOriginT,
} from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/types';
import { StyHeader, StyHighlightedText } from './StyledComponents';
import {
    AmountUpdate,
    CommentUpdate,
    StatusUpdate,
} from './UpdateEventComponents';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

export type UpdateEventProps = {
    user: {
        email: string;
    } | null;
    content: HistoryUpdateContentT;
    label?: string;
    budgetProposal: BudgetProposalT;
    origin?: HistoryOriginT;
};

function UpdateEvent({
    user,
    content,
    label,
    budgetProposal,
    origin = 'inscription',
}: UpdateEventProps): React.ReactElement {
    const { t } = useTranslation();
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();

    if ('comment' in content) {
        return <CommentUpdate content={content} user={user} />;
    }
    if ('amount' in content) {
        return (
            <AmountUpdate
                content={content}
                user={user}
                phase={budgetProposal.phase}
            />
        );
    }
    if ('status' in content) {
        return <StatusUpdate content={content} user={user} />;
    }

    let userLabel: string | null;
    if (user === null) {
        userLabel = t('common.unknown');
    } else {
        userLabel = !isExtractorUser(user) ? user.email : null;
    }
    return (
        <StyHeader>
            <StyHighlightedText>{userLabel}</StyHighlightedText>
            {getSimpleUpdateEventTranslation(
                content,
                origin,
                budgetProposal,
                t,
                sourceTable,
                label,
            )}
        </StyHeader>
    );
}

export default UpdateEvent;
